// Inline delete confirm — replaces window.confirm(). A small trash icon button that, on click, swaps
// in place to "Delete?  Yes / No". State lives in the calling screen (a `confirmId` signal read
// at the top of the list block); this just renders the right control for a row.
import { html } from './t4.js';
import { t } from './i18n.js';
import { icon } from './icons.js';

const stop = fn => e => { e.stopPropagation(); e.preventDefault(); fn(e); };

// Row-level inline delete. `armed` = is THIS row the one confirming. Handlers get the event
// stopped/prevented (safe inside clickable rows). `busy` disables Yes while the request runs.
// Resting state is a small ✕ icon (matches the modal/chip close ✕); the label rides on title/aria.
export function rowDelete({ armed, busy = false, error = '', onArm, onCancel, onDelete, label = t('common.delete', 'Delete') }) {
  // delete was blocked (e.g. language still has words) — show why, right on the row (#34)
  if (armed && error) {
    return html`<span class="confirm-inline confirm-err" @click=${e => e.stopPropagation()}>
      <span class="confirm-errmsg">⚠ ${error}</span>
      <button type="button" class="btn-confirm-no" @click=${stop(onCancel)}>${t('common.ok', 'OK')}</button>
    </span>`;
  }
  if (armed) {
    const q = String(label).replace(/\?+$/, '') + '?';   // avoid "Delete this entry??" when the label already ends in ?
    return html`<span class="confirm-inline" @click=${e => e.stopPropagation()}>
      <span class="confirm-q">${q}</span>
      <button type="button" class="btn-confirm-yes" ?disabled=${busy} @click=${stop(onDelete)}>${busy ? '…' : t('common.yes', 'Yes')}</button>
      <button type="button" class="btn-confirm-no" @click=${stop(onCancel)}>${t('common.no', 'No')}</button>
    </span>`;
  }
  // Delete uses one compact trash control everywhere. The words live on title/aria-label for a11y;
  // the visible control stays compact so it does not compete with the row content.
  return html`<button type="button" class="btn-row-del" title=${label} aria-label=${label} @click=${stop(onArm)}>
    <span class="del-ico" aria-hidden="true">${icon('trash-2', {size:14})}</span></button>`;
}
